import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
// import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { getQueryParams } from '../utils/common';
// import makeRequest from './makeRequest';

let isVidePlayingCheck;
let inactivityTimer;
let refreshTimer = false;

function setAdsKeyValue(key, val) {
  if (key && val && typeof window === 'object') {
    window.Times = window.Times || {};
    window.Times.adsKeys = window.Times.adsKeys || {};
    if (typeof window.Times.adsKeys[key] === 'undefined') {
      window.Times.adsKeys[key] = [val];
    } else if (
      Array.isArray(window.Times.adsKeys[key]) &&
      !window.Times.adsKeys[key].includes(val)
    ) {
      window.Times.adsKeys[key].push(val);
    }
  }
}

export const resetTimer = (refreshTime = 1) => {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    refreshTimer = true;
  }, refreshTime * 60000);
};

export const refreshEventsClearTimeout = () => {
  clearInterval(isVidePlayingCheck);
  clearTimeout(inactivityTimer);
};

const isVideoPlaying = (refreshTime = 1) => {
  if (
    typeof window !== 'undefined' &&
    window.player &&
    ((window.player.store.isAdActive && window.player.store.isAdPlaying) ||
      (!window.player.store.video.completed &&
        !window.player.store.video.paused))
  ) {
    resetTimer(refreshTime);
  }
};

export const isOptimizeReady = () =>
  window.google_optimize && typeof window.google_optimize.get === 'function';

export const getExperimentValue = expId => {
  const queryParam = getQueryParams('experiment'); //for testing purpose
  const experimentVal =
    queryParam != null
      ? parseInt(queryParam, 10)
      : parseInt(window.google_optimize.get(expId), 10);
  return experimentVal;
};
export const executeCallbackFunc = (expId, adName, callbackObj) => {
  if (getExperimentValue(expId) >= 0 && !!adName) {
    setAdsKeyValue(adName, `${expId}_${getExperimentValue(expId)}`);
  }
  const expVal = getExperimentValue(expId);
  if (!isNaN(expVal) && typeof callbackObj[expVal] === 'function') {
    callbackObj[expVal]();
  } else if (typeof callbackObj.default === 'function') {
    callbackObj.default();
  }
  // Object.keys(callbackObj).forEach(key => {
  //   if (parseInt(key, 10) === getExperimentValue(expId)) {
  //     callbackObj[key]();
  //   } else if (typeof callbackObj.default === 'function') {
  //     callbackObj[key]();
  //   }
  // });
};

export const runAbExperiment = (expId, adTargetKey, callbackObj) => {
  if (expId) {
    if (isOptimizeReady()) {
      executeCallbackFunc(expId, adTargetKey, callbackObj);
    } else {
      const timer = setInterval(() => {
        if (isOptimizeReady()) {
          executeCallbackFunc(expId, adTargetKey, callbackObj);
          clearInterval(timer);
        }
      }, 1000);
    }
  } else if (callbackObj && typeof callbackObj.default === 'function') {
    callbackObj.default();
  }
};

export const checkInactiveTab = refreshTime => {
  if (document.visibilityState === 'hidden') {
    resetTimer(refreshTime);
    isVidePlayingCheck = setInterval(() => isVideoPlaying(refreshTime), 2000);
  } else if (refreshTimer) {
    let listingPageName = '';
    const pathArr = window.location.pathname.split('/');
    if (pathArr && pathArr.length > 0 && pathArr[1]) {
      listingPageName = pathArr[1];
    }
    analyticsWrapper(
      'gaAndGrx',
      'send',
      'event',
      window.categoryForSearchGA ||
        window.categoryForGA ||
        `WEB-TOI-Others-${listingPageName}`,
      'Tab_Foreground_Refresh',
    );
    window.location.reload();
  } else {
    refreshEventsClearTimeout();
  }
};

export const getExperimentRefresh = refreshTime => {
  if (refreshTime && refreshTime !== 0) {
    window.addEventListener(
      'visibilitychange',
      () => checkInactiveTab(refreshTime),
      true,
    );
  }
};
